module.exports = __webpack_public_path__ + "static/fonts/Fact-NarrowMedium.c4be759.woff2";